import { apolloClient } from "@td/ui";
import CREATE_TASK_MUTATION from "../mutations/create-task.graphql";
import toastr from "../../toastr";
import { translate } from "@td/shared_utils";

const responseSelector = ({ data: { createCareTeamTask }}) => createCareTeamTask;

export default async (formData) => {
  try {
    const data = await apolloClient.mutate({
      mutation: CREATE_TASK_MUTATION,
      variables: {
        formData,
      },
    });

    return responseSelector(data);
  } catch (e) {
    toastr.error(
      translate(null, "care_team_tasks", "server_error")
    );
  }
};
